import React from 'react';
import {
  elRed
} from '../../styles/colors';
import { Link, useNavigate } from 'app/src/utils/routing';

import DegradedCheck from './DegradedCheck';
import {
  HeaderContainer,
  HeaderLeft,
  HeaderRight,
  HeaderTitle,
  HeaderButtons,
  Button,
  HeaderBackButton,
  SwitchText,
  PreBidAlert
} from './elements';

const buttonStyle = {
  paddingTop: '2px',
  paddingBottom: '5px',
  maxWidth: 'fit-content',
  borderRadius: '25px',
  fontWeight: 400,
  fontSize: '16px'
}

const Header = ({ sale }) => {
  const navigate = useNavigate();

  return (
    <HeaderContainer>
      <HeaderLeft>
        <HeaderTitle>
          {sale.name}
        </HeaderTitle>
        <HeaderButtons>
          <HeaderBackButton
            title='Return to Auction App'
            color={elRed}
            onPress={() => {
              console.log('navigateclick')
              navigate('/')
            }}
          />
          <SwitchText>
            Switch View:
          </SwitchText>
          <Button
            title='Clerk Screen'
            color={elRed}
            style={buttonStyle}
            onPress={() => navigate(`/bidding/clerk/${sale.id}`)}
          />
          <Button
            title='Auctioneer Screen'
            color={elRed}
            style={buttonStyle}
            onPress={() => navigate(`/bidding/auctioneer/${sale.id}`)}
          />
          <Button
            title='Auctioneer HUD'
            color={elRed}
            style={buttonStyle}
            onPress={() => navigate(`/bidding/hud/${sale.id}`)}
          />
        </HeaderButtons>
      </HeaderLeft>
      <HeaderRight>
        {/* {sale?.biddingSaleAsset?.preBids.length ?
          <PreBidAlert>
            Pre Bid Alert
          </PreBidAlert> :
          null
        } */}
        <DegradedCheck />
      </HeaderRight>
    </HeaderContainer>
  )
}

export default Header;
